import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { backgroundOptions } from '../common/backgrounds';

const { FiX, FiDownload, FiCheck } = FiIcons;

const BrandSVGs = {
  linkedin: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z",
  twitter: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z",
  github: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z",
  instagram: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
  youtube: "M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z",
  facebook: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.641c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.513c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.737-.9 10.125-5.864 10.125-11.854z",
  tiktok: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.65-1.58-1.09v8.32c0 1.58-.54 3.14-1.56 4.38-1.02 1.24-2.52 2.05-4.13 2.23-1.6.18-3.23-.17-4.58-1.05-1.35-.88-2.32-2.31-2.7-3.87-.38-1.56-.05-3.21.94-4.53 1-1.31 2.5-2.18 4.12-2.38.29-.04.58-.05.87-.04v4.07a2.8 2.8 0 0 0-.25 5.56 2.8 2.8 0 0 0 2.83-2.8V.02h.34z",
  dribbble: "M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm9.86-11.86c.014.043.014.086.014.129.549 2.661-.179 5.347-1.778 7.444-2.19 2.875-5.742 4.417-9.358 3.896-.757-.109-1.478-.32-2.158-.621 2.37-1.878 5.688-2.603 8.878-1.967 1.547-2.924 2.766-5.918 4.402-8.881zm-9.644-9.923c3.255-.544 6.578.475 9.014 2.589-1.498 2.667-2.664 5.431-4.067 8.169-3.016-.69-6.353.111-8.729 2.053-1.011-1.614-1.55-3.52-1.47-5.523.098-2.428 1.157-4.629 2.871-6.208 2.458 1.91 5.452 3.12 8.711 3.491-1.531-1.622-3.845-2.651-6.33-2.571zm-3.69 12.378c2.254-1.696 5.305-2.381 8.138-1.849.529.102 1.039.255 1.528.452-1.719 2.067-2.843 4.542-3.234 7.15-2.505-.333-5.264-1.398-7.85-3.013.385-.956.885-1.869 1.418-2.74zm13.15 1.874c-.266-2.55-1.354-4.968-3.075-6.936 2.083-1.96 4.95-2.935 7.848-2.573.048.43.078.865.078 1.309 0 3.204-1.258 6.134-3.324 8.286-.484-.038-.971-.059-1.46-.059-.022-.009-.045-.018-.067-.027z"
};

const FeatherSVGs = {
    user: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>',
    folder: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>',
    mail: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>',
    mapPin: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>',
    zap: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>',
    externalLink: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>'
};

function ExportModal({ bioData, onClose }) {
  const [isExporting, setIsExporting] = useState(false);
  const [exportComplete, setExportComplete] = useState(false);

  const generateHTML = () => {
    let bgCss = '';
    let bgWrapper = '';
    
    if (bioData.backgroundType === 'solid') {
        bgCss = `background: ${bioData.customBackground || '#000'};`;
    } else if (bioData.backgroundType === 'gradient') {
        bgCss = `background: ${bioData.customBackground || 'linear-gradient(to bottom, #000, #111)'};`;
    } else {
        const currentBg = backgroundOptions.find(b => b.id === bioData.backgroundId) || backgroundOptions[0];
        bgCss = currentBg.css;
        bgWrapper = currentBg.wrapper;
    }

    const faviconUrl = bioData.avatar || "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90' fill='%23666'>👤</text></svg>";

    const socialLinksHtml = Object.keys(bioData.socials).map(key => {
        const url = bioData.socials[key];
        const svgPath = BrandSVGs[key];
        if (!url || !svgPath) return '';
        return `
            <a href="${url}" target="_blank" class="social-btn" aria-label="${key}">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="${svgPath}"></path></svg>
            </a>
        `;
    }).join('');

    const projectsHtml = bioData.projects && bioData.projects.length > 0 ? bioData.projects.map(proj => `
        <a href="${proj.url || '#'}" target="_blank" class="project-card">
            <div style="opacity:0.5; margin-right:8px; margin-top:4px;">${FeatherSVGs.externalLink}</div>
            <div style="min-width:0; flex:1;">
                <div style="font-weight:bold; font-size:0.9rem; margin-bottom:2px; color:inherit; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${proj.name || 'Untitled'}</div>
                <div style="font-size:0.75rem; opacity:0.6; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;">${proj.desc || ''}</div>
            </div>
        </a>
    `).join('') : '<div style="grid-column: 1 / -1; display:flex; align-items:center; justify-content:center; opacity:0.4; font-style:italic; border:1px dashed rgba(255,255,255,0.1); border-radius:12px; height:100%;">Add projects to showcase your work...</div>';

    return `<!doctype html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${bioData.name || 'My Bio'}</title>
    <link rel="icon" href="${faviconUrl}" />
    <style>
        :root {
            --card-bg: ${bioData.colors.card};
            --text-main: ${bioData.colors.text};
            --accent: ${bioData.colors.accent};
            --spotlight: rgba(255,255,255,0.15);
        }
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
            font-family: system-ui, -apple-system, sans-serif;
            color: var(--text-main);
            min-height: 100vh;
            display: flex;
            justify-content: center;
            padding: 40px 20px;
            overflow-x: hidden;
            background: #000;
        }
        
        .site-bg {
            position: fixed;
            inset: 0;
            z-index: -1;
            ${bgCss}
        }

        .container {
            width: 100%;
            max-width: 1150px;
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 20px;
            position: relative;
            z-index: 10;
            grid-auto-rows: 1fr;
        }

        /* Desktop Spans */
        .c-profile { grid-column: span 3; }
        .c-time { grid-column: span 2; }
        .c-about { grid-column: span 2; }
        .c-work { grid-column: span 3; }
        .c-contact { grid-column: span 2; }
        .c-tech { grid-column: span 3; }

        @media (max-width: 1024px) { 
            .container { grid-template-columns: repeat(2, 1fr); } 
            
            /* Tablet Spans */
            .c-profile { grid-column: span 2; }
            .c-time { grid-column: span 1; }
            .c-about { grid-column: span 1; }
            .c-work { grid-column: span 2; }
            .c-contact { grid-column: span 2; }
            .c-tech { grid-column: span 2; }
        }
        
        @media (max-width: 768px) { 
            .container { grid-template-columns: 1fr; grid-auto-rows: auto; } 
            
            /* Mobile Spans */
            .c-profile, .c-time, .c-about, .c-work, .c-contact, .c-tech { grid-column: span 1; }
        }

        .chroma-card {
            position: relative;
            background: var(--card-bg);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 24px;
            overflow: hidden;
            padding: 32px;
            transition: transform 0.2s ease, border-color 0.3s ease;
            display: flex;
            flex-direction: column;
            --mouse-x: 50%; --mouse-y: 50%;
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
            box-shadow: 0 4px 30px rgba(0,0,0,0.1);
        }
        .chroma-card::before {
            content: ''; position: absolute; inset: 0;
            background: radial-gradient(800px circle at var(--mouse-x) var(--mouse-y), var(--spotlight), transparent 40%);
            opacity: 0; transition: opacity 0.5s ease; pointer-events: none;
        }
        .chroma-card:hover::before { opacity: 1; }
        .chroma-card:hover { border-color: var(--accent); box-shadow: 0 10px 40px -10px rgba(0,0,0,0.5); }
        
        .content { position: relative; z-index: 2; height: 100%; display: flex; flex-direction: column; }
        
        .name { font-size: 3rem; font-weight: 700; margin-bottom: 8px; line-height: 1.1; word-wrap: break-word; }
        .title { font-size: 1.25rem; opacity: 0.8; margin-bottom: 24px; font-weight: 300; word-wrap: break-word; }
        @media (max-width: 640px) { .name { font-size: 2rem; } .title { font-size: 1.1rem; } }
        
        .social-btn {
            display: inline-flex; width: 48px; height: 48px;
            background: rgba(255,255,255,0.05); border-radius: 12px;
            border: 1px solid rgba(255,255,255,0.1);
            color: inherit; align-items: center; justify-content: center;
            text-decoration: none; margin-right: 8px; margin-bottom: 8px;
            transition: all 0.2s;
        }
        .social-btn:hover { background: rgba(255,255,255,0.2); color: var(--accent); border-color: var(--accent); }

        .project-card {
            display: flex; align-items: start; padding: 16px;
            background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.05);
            border-radius: 12px; text-decoration: none; color: inherit;
            transition: background 0.2s; height: 100%;
        }
        .project-card:hover { background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.2); }
        .project-card .desc { font-size: 0.75rem; opacity: 0.6; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

        .pill { padding: 6px 16px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 99px; font-size: 0.85rem; display: inline-block; margin: 4px; cursor: default; white-space: nowrap; }
        .pill:hover { background: rgba(255,255,255,0.1); }
        
        .icon-box { width: 40px; height: 40px; border-radius: 50%; background: rgba(255,255,255,0.1); display: flex; align-items: center; justify-content: center; margin-bottom: 12px; color: var(--accent); flex-shrink: 0; }
        .icon-box svg { display: block; }

        .contact-item { padding: 16px; background: rgba(255,255,255,0.05); border-radius: 12px; border: 1px solid rgba(255,255,255,0.05); margin-bottom: 12px; transition: background 0.2s; }
        .contact-item:hover { background: rgba(255,255,255,0.1); }

        /* Responsive Profile Layout */
        .profile-layout { display: flex; gap: 24px; justify-content: space-between; align-items: flex-start; height: 100%; }
        .profile-info { flex: 1; display: flex; flex-direction: column; height: 100%; min-width: 0; }
        .avatar-box { width: 140px; height: 140px; border-radius: 50%; border: 4px solid rgba(255,255,255,0.05); background: rgba(255,255,255,0.05); overflow: hidden; flex-shrink: 0; box-shadow: 0 10px 30px rgba(0,0,0,0.3); }
        
        @media (max-width: 640px) {
            .profile-layout { flex-direction: column-reverse; align-items: center; text-align: center; }
            .profile-info { width: 100%; align-items: center; }
            .avatar-box { width: 110px; height: 110px; margin-bottom: 16px; }
            .social-btn { margin: 4px; }
        }
    </style>
</head>
<body>
    <div class="site-bg">
        ${bgWrapper || ''}
    </div>

    <div class="container">
        <!-- ROW 1 -->
        <div class="chroma-card c-profile">
            <div class="content">
                <div class="profile-layout">
                    <div class="profile-info">
                        <div style="flex: 1;">
                            <div style="font-size:0.65rem; text-transform:uppercase; letter-spacing:0.15em; opacity:0.6; margin-bottom:12px; background:rgba(255,255,255,0.1); padding:4px 8px; border-radius:4px; display:inline-block;">Welcome</div>
                            <h1 class="name">${bioData.name || 'Name'}</h1>
                            <p class="title">${bioData.title || 'Title'}</p>
                        </div>
                        <div style="margin-top: 20px; display:flex; flex-wrap:wrap;">
                            ${socialLinksHtml}
                        </div>
                    </div>
                    <div class="avatar-box">
                        ${bioData.avatar ? `<img src="${bioData.avatar}" style="width:100%; height:100%; object-fit:cover;">` : ''}
                    </div>
                </div>
            </div>
        </div>

        <div class="chroma-card c-time" style="align-items:center; justify-content:center; text-align:center;">
            <div class="content" style="align-items:center; justify-content:center;">
                <div id="current-time" style="font-size:2.5rem; font-family:monospace; font-weight:700; letter-spacing:-1px;">--:--</div>
                <div style="opacity:0.6; font-size:0.65rem; text-transform:uppercase; letter-spacing:2px; margin-top:4px;">${bioData.timezone || 'UTC'}</div>
            </div>
        </div>

        <!-- ROW 2 -->
        <div class="chroma-card c-about">
            <div class="content">
                <div class="icon-box">${FeatherSVGs.user}</div>
                <h3 style="margin-bottom:12px; font-weight:bold; font-size:1.1rem;">About</h3>
                <p style="font-size:0.9rem; line-height:1.6; opacity:0.75; white-space: pre-wrap;">${bioData.about || '...'}</p>
            </div>
        </div>

        <div class="chroma-card c-work">
             <div class="content">
                <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:24px; flex-wrap:wrap; gap:12px;">
                    <div style="display:flex; align-items:center; gap:16px;">
                        <div class="icon-box" style="margin:0;">${FeatherSVGs.folder}</div>
                        <h3 style="font-weight:bold; margin:0; font-size:1.25rem;">Selected Work</h3>
                    </div>
                    <div class="pill" style="display:flex; align-items:center; gap:8px;">
                        <span style="display:block; width:8px; height:8px; background:#22c55e; border-radius:50%;"></span>
                        ${bioData.availability || 'Available'}
                    </div>
                </div>
                <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap:12px; flex:1;">
                     ${projectsHtml}
                </div>
            </div>
        </div>

        <!-- ROW 3 -->
        <div class="chroma-card c-contact">
            <div class="content" style="justify-content:space-between;">
                <h3 style="font-weight:bold; margin-bottom:16px; font-size:1.1rem;">Contact</h3>
                <div style="flex:1; display:flex; flex-direction:column; gap:12px;">
                    <div class="contact-item">
                        <div style="font-size:0.75rem; opacity:0.5; margin-bottom:4px; display:flex; align-items:center; gap:6px;">
                            ${FeatherSVGs.mail} EMAIL
                        </div>
                        <div style="font-size:0.9rem; word-break:break-all;">${bioData.email || '-'}</div>
                    </div>
                    <div class="contact-item">
                        <div style="font-size:0.75rem; opacity:0.5; margin-bottom:4px; display:flex; align-items:center; gap:6px;">
                            ${FeatherSVGs.mapPin} LOCATION
                        </div>
                        <div style="font-size:0.9rem;">${bioData.location || '-'}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="chroma-card c-tech">
             <div class="content" style="justify-content:center;">
                <div style="display:flex; align-items:center; gap:12px; margin-bottom:24px;">
                     <div style="color:var(--accent);">${FeatherSVGs.zap}</div>
                     <h3 style="font-weight:bold; font-size:1.1rem;">Tech Stack</h3>
                </div>
                <div style="display:flex; flex-wrap:wrap; gap:8px;">
                    ${bioData.learning.map(s => `<span class="pill">${s}</span>`).join('')}
                </div>
             </div>
        </div>
    </div>
    
    <script>
      document.addEventListener('DOMContentLoaded', () => {
        const cards = document.querySelectorAll('.chroma-card');
        cards.forEach(card => {
          card.addEventListener('mousemove', (e) => {
            const rect = card.getBoundingClientRect();
            card.style.setProperty('--mouse-x', (e.clientX - rect.left) + 'px');
            card.style.setProperty('--mouse-y', (e.clientY - rect.top) + 'px');
          });
        });
        setInterval(() => {
            const now = new Date();
            const timeEl = document.getElementById('current-time');
            if(timeEl) timeEl.textContent = now.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' });
        }, 1000);
      });
    </script>
</body>
</html>`;
  };

  const handleExport = async () => {
    setIsExporting(true);
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    const htmlContent = generateHTML();
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${(bioData.name || 'bio').toLowerCase().replace(/\s+/g, '-')}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    setIsExporting(false);
    setExportComplete(true);
    setTimeout(() => onClose(), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }} 
        animate={{ opacity: 1, scale: 1 }}
        className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 max-w-md w-full shadow-2xl"
      >
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-bold text-white">Export Bio</h3>
          <button onClick={onClose} className="p-2 hover:bg-zinc-800 rounded-lg transition-colors text-zinc-400 hover:text-white">
            <SafeIcon icon={FiX} className="text-lg" />
          </button>
        </div>
        <div className="space-y-4 text-center">
            <p className="text-sm text-zinc-400">
                Generating <strong>{bioData.name || 'Bio'}'s</strong> personal site.
            </p>
            {exportComplete ? (
                <div className="p-4 bg-green-500/10 text-green-400 rounded-xl border border-green-500/20 flex items-center justify-center gap-2">
                    <SafeIcon icon={FiCheck} /> Downloaded!
                </div>
            ) : (
                <button 
                  onClick={handleExport}
                  disabled={isExporting}
                  className="w-full py-3 bg-white text-black font-bold rounded-xl hover:bg-zinc-200 transition-colors flex items-center justify-center gap-2"
                >
                    {isExporting ? 'Building...' : <><SafeIcon icon={FiDownload} /> Download HTML</>}
                </button>
            )}
        </div>
      </motion.div>
    </div>
  );
}

export default ExportModal;